import { defineComponent as u, ref as p, computed as b, createBlock as i, openBlock as o, unref as r, createSlots as k, withCtx as t, createTextVNode as n, toDisplayString as l, createElementVNode as h, normalizeClass as v, createCommentVNode as y } from "vue";
import { RevListItemInteractive as S } from "@ds/components/ListItemInteractive";
import x from "../../../icons/generated/IconCheckLarge.vue2.js";
import { tw as s } from "../../../utils/tailwind.js";
import C from "./ListItemPlaceholder.vue2.js";
const z = /* @__PURE__ */ u({
  __name: "InputSelectSearchableItem",
  props: {
    hideCheckbox: { type: Boolean, default: !1 },
    isSelected: { type: Boolean },
    label: {},
    description: { default: null },
    suffix: { default: null },
    listboxElement: {}
  },
  setup(d) {
    const f = d, a = p(!1);
    function m() {
      a.value = !0;
    }
    const c = b(() => [
      s`rounded-sm pointer-events-none mt-2 flex size-20 items-center justify-center ease-in motion-safe:transition-colors motion-safe:duration-[50ms]`,
      f.isSelected ? s`bg-action-default-low-pressed text-onaction-default-low-pressed` : s`bg-action-default-low border-static-default-hi border`
    ]);
    return (e, I) => a.value ? (o(), i(r(S), {
      key: 0,
      "aria-label": e.label,
      "aria-selected": String(e.isSelected),
      role: "option",
      tabindex: "-1"
    }, k({
      label: t(() => [
        n(l(e.label), 1)
      ]),
      _: 2
    }, [
      e.hideCheckbox ? void 0 : {
        name: "prefix",
        fn: t(() => [
          h("div", {
            class: v(c.value)
          }, [
            e.isSelected ? (o(), i(r(x), {
              key: 0,
              size: "16"
            })) : y("", !0)
          ], 2)
        ]),
        key: "0"
      },
      e.description ? {
        name: "description",
        fn: t(() => [
          n(l(e.description), 1)
        ]),
        key: "1"
      } : void 0,
      e.suffix ? {
        name: "suffix",
        fn: t(() => [
          n(l(e.suffix), 1)
        ]),
        key: "2"
      } : void 0
    ]), 1032, ["aria-label", "aria-selected"])) : (o(), i(C, {
      key: 1,
      class: "min-h-64",
      "listbox-element": e.listboxElement,
      onIntersect: m
    }, null, 8, ["listbox-element"]));
  }
});
export {
  z as default
};
